import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { AiChatBotPageData } from "../data/ai-chatbot-data";
import { useTranslation } from "react-i18next";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewBenefitsSection from "../components/new-banefits-section/NewBenefitsSection";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import IntigrationIconsSection from "../components/integration-icons-section/IntigrationIconsSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import AreasWeServe from "../components/areas-we-serve/AreasWeServe";
import ChatbotBanner from "../components/ChatbotBanner/ChatbotBanner";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import ChatbotIntigratedSection from "../components/ChatBotIntigratedSection/ChatbotIntigratedSection";
import TechStack from "../components/techstack/TechStack";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";
import IntigrationPlatforms from "../components/IntigrationPlatforms/IntigrationPlatforms";
import ModelAgnostic from "../components/ModelAgnostic/ModelAgnostic";
import SubscriptionPlans from "../components/SubscriptionPlans/SubscriptionPlans";

const AiChatBotServices = () => {
  const { t } = useTranslation("footer");
  const footerCtaContent = t("footerCtaContent", { returnObjects: true });

  const { t: stackData } = useTranslation("aiDevelopmentPageContent");
  const coverTheStackData = stackData("aiDevCoverTheStackSection", {
    returnObjects: true,
  });

  return (
    <>
      <Helmet>
        <title>AI Chatbot Development Services for Businesses | Bitsclan</title>
        <meta
          name="description"
          content="Accelerate business growth with AI chatbot services from a top chatbots development company. Our team builds custom chatbots that enhance customer engagement and automate tasks."
        />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href="https://bitsclan.com/ai-chatbot-development-services" />
      </Helmet>

      <MegaMenu />

      <ChatbotBanner
        shortHeading="Transform Customer Engagement with Chatbots"
        mainHeading="AI Chatbots That Drive <span>Unmatched Customer</span> Engagement Through 24/7 Automation"
        description="Empower your brand with intelligent chatbots trained on your own data, documents, & website. Automate customer interactions, capture leads, & provide instant support across your digital touchpoints day & night."
        buttonText="Start Your AI Chatbot Journey"
        bannerImage="/images/why-us-section/chatbot-banner.png"
      />
      <TrustedPartner category={"chatbot"} showGoogleIcons={true} heading="Trusted & Partnered by Businesses Worldwide to Build Smarter Chatbot Solutions" />

      <OurServices
        shortHeading={"AI Chatbot Development Services"}
        buttonText="Get Your Chatbot Now"
        servicesCardsData={AiChatBotPageData?.services}
        mainHeading="Tailored Chatbot Solutions That Redefine Engagement & Support"
        // mainHeading=" No Matter What You are Building, We Can Help with Expert <span>AI Solutions</span>"
        description="Our AI chatbot development company partners with brands to create a unified strategy, integrate AI seamlessly, & scale customer support, automation, & personalized experiences across multiple platforms."
      />

      <NewTestimonials
        shortHeading={AiChatBotPageData?.testimonialData?.shortHeading}
        mainHeading={AiChatBotPageData?.testimonialData?.mainHeading}
        description={AiChatBotPageData?.testimonialData?.description}
        content={AiChatBotPageData?.testimonialData?.testimonials}
      />

      <WhyChooseUs
        heading={AiChatBotPageData?.whyUsSectionData?.heading}
        greenHeading={AiChatBotPageData?.whyUsSectionData?.greenHeading}
        content={AiChatBotPageData?.whyUsSectionData?.content}
        shortHeading={AiChatBotPageData?.whyUsSectionData?.shortHeading}
        stats={AiChatBotPageData?.whyUsSectionData?.stats}
        imageStats={AiChatBotPageData?.whyUsSectionData?.imageStats}
        cta={AiChatBotPageData?.whyUsSectionData?.cta}
        sectionImage={AiChatBotPageData?.whyUsSectionData?.image}
      />

      <NewCaseStudySection
        heading={AiChatBotPageData?.caseStudyContent?.heading}
        shortHeading={AiChatBotPageData?.caseStudyContent?.shortHeading}
        description={AiChatBotPageData?.caseStudyContent?.description}
        filter={"chatbot"}
      />

      <ChatbotIntigratedSection content={AiChatBotPageData?.integrationsData} />

      {/* <SubscriptionPlans /> */}

      <SimpleModels content={AiChatBotPageData?.engagementModels} />

      <TechStack content={AiChatBotPageData?.techStackData} />


      {/* <ChatBotWorkFlow /> */}

      {/* <IntigrationPlatforms /> */}

      {/* <IntigrationIconsSection content={AiChatBotPageData?.chatbotIntigration} /> */}

      <NewBenefitsSection />

      <PioneeringChange
        shortHeading="Industries We Serve"
        tabData={AiChatBotPageData?.industriesSectionMain}
        greenHeading={"Solutions Built for the Unique Demands of Every Industry"}
        mainHeading={"Specialized Chatbot "}
        content={"Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights."}
        serviceTags={[
          { title: "AI Chatbots", link: "/ai-chatbot-development-services" },
          { title: "Virtual Assistants", link: "/ai-automation-agency" },
          { title: "Conversational AI", link: "/generative-ai-development-services" }
        ]}
      />

      {/* <IndustriesTabs defaultTab={"Healthcare"} shortHeading="Industries We Serve" mainheading="Our Industry-Specific Chatbot Development Expertise" description="Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights." /> */}

      <SecurityFIrstSection />

      <ModelAgnostic />

      <CoverTheStack
        whereStart={"Deep learning frameworks"}
        shortHeading={"Technology Stack for Chatbot Development"}
        mainHeading={"Foundational Technologies Driving Conversational Intelligence"}
        subHeading={
          "The right technology stack for chatbot development will depend on your intended use cases & channels. We engage with the leading providers from Microsoft Azure & AWS to Google Cloud for dependable, secure, & scalable solutions."
        }
        tabs={AiChatBotPageData?.techStack?.tabs}
        tabItems={AiChatBotPageData?.techStack?.tabItems}
      />

      <NewRoadMap roadmapContent={AiChatBotPageData?.roadmapContent} />

      <TrendsInsights
        category="ai-developmet"
        heading={AiChatBotPageData?.trendingInsights.heading}
        description={AiChatBotPageData?.trendingInsights.description}
      />

      <FAQ
        faqs={AiChatBotPageData.faqSection.questionAnswers}
        mainHeading={AiChatBotPageData.faqSection.heading}
      />

      <AreasWeServe />

      <SoftwareCompanyCta content={AiChatBotPageData?.companyCta} />
      <Footer />
    </>
  );
};

export default AiChatBotServices;
